module.exports = __webpack_public_path__ + "static/media/apple-touch-icon.cba95670.png";